// import { create } from "zustand";

// interface Workspace {
//   _id: string;
//   color?: string;
//   name: string;
//   users: string[];
//   reports: any[];
//   createdAt: string;
//   updatedAt: string;
// }

// interface WorkspaceState {
//   currentWorkspace: Workspace | null;
//   workspaces: Workspace[];
//   setCurrentWorkspace: (workspace: Workspace) => void;
//   setWorkspaces: (workspaces: Workspace[]) => void;
//   addWorkspace: (workspace: Workspace) => void;
//   removeWorkspace: (id: string) => void;
//   updateWorkspace: (id: string, updates: Partial<Workspace>) => void;
// }

// export const useWorkspaceStore = create<WorkspaceState>((set, get) => ({
//   currentWorkspace: null,
//   workspaces: [],

//   setCurrentWorkspace: (workspace) => {
//     set({ currentWorkspace: workspace });
//   },

//   setWorkspaces: (workspaces) => {
//     set({ workspaces });
//     // Set first workspace as current if none selected
//     if (!get().currentWorkspace && workspaces.length > 0) {
//       set({ currentWorkspace: workspaces[0] });
//     }
//   },

//   addWorkspace: (workspace) => {
//     set((state) => ({
//       workspaces: [...state.workspaces, workspace],
//     }));
//   },

//   removeWorkspace: (id) => {
//     set((state) => ({
//       workspaces: state.workspaces.filter((w) => w._id !== id),
//       currentWorkspace:
//         state.currentWorkspace?._id === id
//           ? state.workspaces[0] || null
//           : state.currentWorkspace,
//     }));
//   },

//   updateWorkspace: (id, updates) => {
//     set((state) => ({
//       workspaces: state.workspaces.map((w) =>
//         w._id === id ? { ...w, ...updates } : w
//       ),
//       // Also update currentWorkspace if it's the one being updated
//       currentWorkspace:
//         state.currentWorkspace?._id === id
//           ? { ...state.currentWorkspace, ...updates }
//           : state.currentWorkspace,
//     }));
//   },
// }));

import { create } from "zustand";
import { persist } from "zustand/middleware";

interface Workspace {
  _id: string;
  color?: string;
  name: string;
  users: any[];
  reports: any[];
  createdAt: string;
  updatedAt: string;
  jira?: any;
  sentry?: {
    organizationSlug: string;
    projectSlug: string;
    installationId: string;
  };
  activeReportsTab?: string;
}

interface WorkspaceState {
  currentWorkspace: Workspace | null;
  workspaces: Workspace[];
  setCurrentWorkspace: (workspace: Workspace | null) => void;
  setWorkspaces: (workspaces: Workspace[]) => void;
  addWorkspace: (workspace: Workspace) => void;
  removeWorkspace: (id: string) => void;
  updateWorkspace: (id: string, updates: Partial<Workspace>) => void;
}

export const useWorkspaceStore = create<WorkspaceState>()(
  persist(
    (set, get) => ({
      currentWorkspace: null,
      workspaces: [],

      setCurrentWorkspace: (workspace) => {
        set({ currentWorkspace: workspace });
      },

      setWorkspaces: (workspaces) => {
        set({ workspaces });
        // Only set a default workspace if none is currently selected
        // Don't auto-correct currentWorkspace - user may be viewing as guest
        const current = get().currentWorkspace;
        if (!current && workspaces.length > 0) {
          set({ currentWorkspace: workspaces[0] });
        }
      },

      addWorkspace: (workspace) => {
        set((state) => ({
          workspaces: [...state.workspaces, workspace],
        }));
      },

      removeWorkspace: (id) => {
        set((state) => ({
          workspaces: state.workspaces.filter((w) => w._id !== id),
          currentWorkspace:
            state.currentWorkspace?._id === id
              ? state.workspaces[0] || null
              : state.currentWorkspace,
        }));
      },

      updateWorkspace: (id, updates) => {
        set((state) => ({
          workspaces: state.workspaces.map((w) =>
            w._id === id ? { ...w, ...updates } : w
          ),
          // Also update currentWorkspace if it's the one being updated
          currentWorkspace:
            state.currentWorkspace?._id === id
              ? { ...state.currentWorkspace, ...updates }
              : state.currentWorkspace,
        }));
      },
    }),
    {
      name: "workspace-storage", // unique name for localStorage key
      partialize: (state) => ({ currentWorkspace: state.currentWorkspace }), // only persist currentWorkspace
    }
  )
);
